import React from 'react';
import './css/Progressbar.css';


class Progressbar extends React.Component {
    render() {
        //console.log(this.props.tasks[0].completion());
        const compCount=this.props.tasks.map((task) => task.completion()[0]).reduce((acc,task)=>acc+task,0)
        const total=this.props.tasks.map((task) => task.completion()[1]).reduce((acc,task)=>acc+task,0)
        return (
            <div className = "component-Progressbar">
                <div style = {{width : `${compCount/total * 400}px`}}>
                </div>
            </div>



        )
    }
}

export default Progressbar;
